module.exports = __webpack_public_path__ + "assets/media/user-member-lovel04.cb3b5995.png";